import css from 'styled-jsx/css';

export default css`
  .SignInPrompt {
    margin: 5rem;
    text-align: center;
    font-size: 1.2rem;
  }
`;
